import { useToast } from "@chakra-ui/react";
import { useCallback } from "react";
import { Edge, Node, useReactFlow } from "reactflow";
import { useNodeNotificationsProvider } from "../context/NodeNotificationsProvider";
import { EdgeType } from "../models/edgeType";
import NodeError from "../models/nodes/NodeError";
import { NodeData, NodeType } from "../models/nodeType";
import { exportRuntimeData } from "../utils/exportRuntimeData";

export default function useExportRuntimeData() {
  const toast = useToast();

  const { insertNotification } = useNodeNotificationsProvider();

  const { fitView } = useReactFlow();

  const exportQuestNodes = useCallback(
    (nodes: Node<NodeType>[], edges: Edge<EdgeType>[], initialNodeTypes: NodeType<NodeData>[] = []) => {
      try {
        return exportRuntimeData(nodes.filter(({ data: { nodeClass } }) => nodeClass !== "meta"), edges, initialNodeTypes);
      } catch (error) {
        if (error instanceof NodeError) {
          const { nodeId } = error;

          fitView({ nodes: [{ id: nodeId }] });

          toast({ title: "Quest export error", status: "error", description: error.message });
        }

        return [];
      }
    },
    [insertNotification, fitView]
  );

  return {
    exportQuestNodes,
  };
}
